import { connect } from "react-redux"

import InsightAreaFingerprintWidget from "../InsightAreaFingerprintWidget"

const mapStateToProps = ({ entities, presentation }, { topicId }) => ({
    fingerprintFlow:
        entities.topicFingerprints[topicId] &&
        entities.topicFingerprints[topicId].flow,
    mappings: presentation.insightAreas.workingModel.mappings.reduce(
        (newMappings, { positive }) =>
            newMappings.concat(positive.map(({ name }) => name)),
        []
    ),
})

export default connect(mapStateToProps)(InsightAreaFingerprintWidget)
